// import banner from './components/home/banner/store';

const state = {
};

const getters = {
};

const actions = {
};

const mutations = {
};

// 所有容器画布的业务组件store在这里注册
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        // banner
    }
};

